import { storage, firestore, functions, firebase, auth } from '../../lib/firebase';
import { GET_VOUCHER_CATEGORIES, GET_VOUCHER_COMPANIES, GET_VOUCHER_LIST, GET_COMPANY_VOUCHERS, GET_COMPANY_OUTREACH_VOUCHERS, SORT_COMPANY_VOUCHERS, GET_VOUCHER_SALES_DATA, SORT_COMPANY_OUTREACH_VOUCHERS } from '../index';
import { DB_TABLE_NAME } from '../../const/firebase';

import moment from 'moment';
import { uuid } from '../../lib/uuid';

let unsubscribe;

/*
export const getCompanyVouchers = (companyId) => dispatch => {

    const vouchers = firestore.collection('companyVouchers').doc(companyId);
    vouchers.get().then((querySnapshot) => {
        let payload = {};

        console.log(querySnapshot.data());

        querySnapshot.forEach(function(doc) {
          payload = {...payload, [doc.id]: doc.data()}
        });

        dispatch({
          type: GET_COMPANY_VOUCHERS,
          payload
        });
    })
}; */

/* export const getCompanyVouchers = (companyId) => (dispatch) => new Promise(async (resolve, reject) => {
  console.log('action - getAllAdmins');
  //  const vouchersRef = firestore.collection('companyVouchers').doc(companyId);
    const vouchersRef = firestore.collection('companyData').doc(companyId).collection('vouchers');
    const snapshot = await vouchersRef.get();

    if (!snapshot.docs) {
      console.log('No such documents!');
    } else {
      const vouchers = {};

      snapshot.docs.map(doc => {
        console.log(doc.id);
        vouchers[doc.id] = doc.data();
      })

      console.log(vouchers);

      dispatch({
          type: GET_COMPANY_VOUCHERS,
          payload: vouchers,
      })

      return resolve('success');
    }
}); */

export const unsubscribeVouchers = () => dispatch => new Promise((resolve, reject) => {
  if (unsubscribe) {
    unsubscribe();
  }

  return resolve();
});

export const getCompanyVouchers = (companyId) => (dispatch) => new Promise(async (resolve, reject) => {
  const user = auth.currentUser;


  if (user) {
    //  const vouchersRef = firestore.collection('companyData').doc(companyId).collection('vouchers');

    const companyRef = firestore.collection('companies').doc(companyId);
    const vouchersRef = firestore.collection('vouchers').where('company', '==', companyRef);

    //  unsubscribe = vouchersRef.onSnapshot(docSnapshot => {

    const docSnapshot = await vouchersRef.get();

    if (!docSnapshot.docs) {
      return resolve();
    } else {
      const vouchers = {};
      let promises2 = [];

      let companyPendingChanges = null;

      const companyPendingRef = firestore.collection('companyPending').doc(companyId);

      const companyPendingSnapshot = await companyPendingRef.get();

      if (!companyPendingSnapshot.exists) {
        companyPendingChanges = null;
      } else {
        companyPendingChanges = companyPendingSnapshot.data();
      }

      console.log('companyPendingChanges', companyPendingChanges);

      docSnapshot.docs.map(async (doc) => {
        let voucherPendingChanges = null;

        const data = doc.data();

        promises2.push(new Promise(async (resolve3, reject3) => {
          if (data.hasPendingChanges) {
            let voucherPendingRef = firestore.collection('vouchersPending').doc(doc.id);

            voucherPendingRef.get().then((res2) => {
              voucherPendingChanges = res2.data();

              //  console.log('getCompanyVouchers voucherPendingChanges', { voucherPendingChanges });

              vouchers[doc.id] = { ...data, voucherPendingChanges, companyPendingChanges };

              return resolve3();
            }).catch((err2) => {
              voucherPendingChanges = null;

              //  console.log('getCompanyVouchers voucherPendingChanges', { voucherPendingChanges });

              vouchers[doc.id] = { ...data, voucherPendingChanges, companyPendingChanges };
              return resolve3();
            });
          } else {
            //  console.log('getCompanyVouchers voucherPendingChanges', { voucherPendingChanges });

            vouchers[doc.id] = { ...data, voucherPendingChanges, companyPendingChanges };

            return resolve3();
          }
        }));

        //  console.log('getCompanyVouchers voucherPendingChanges', { voucherPendingChanges });

        //  vouchers[doc.id] = { ...data, voucherPendingChanges };
      })

      //  console.log('getCompanyVouchers promises length', { length: promises2.length });

      Promise.all(promises2).then(() => {
        //  console.log('getCompanyVouchers voucherPendingChanges 2', { vouchers });

        dispatch({
          type: GET_COMPANY_VOUCHERS,
          payload: vouchers,
        });

        return resolve('success');
      }).catch(err => {
        dispatch({
          type: GET_COMPANY_VOUCHERS,
          payload: vouchers,
        });

        return resolve('success');
      })
    }
    //  }, err => {
    //    console.log(`Encountered error: ${err}`);
    //  });
  }
});



export const changeCampaignCustomUrl = ({ customUrlModalId, customUrlModalNewUrlValue }) => (dispatch) => new Promise(async (resolve, reject) => {
  console.log('changeCampaignCustomUrl', customUrlModalId, customUrlModalNewUrlValue);
  if (!customUrlModalId || !customUrlModalNewUrlValue) {
    return resolve('misising data');
  } else {
    console.log('test');
  }

  console.log("updateSubscriptionSetup 2", customUrlModalId, customUrlModalNewUrlValue);

  const changeCampaignCustomUrlFunction = functions.httpsCallable('changeCampaignCustomUrl');

  await changeCampaignCustomUrlFunction({ campaignId: customUrlModalId, customUrl: customUrlModalNewUrlValue }).then((result) => {

    console.log('updateSubscriptionSetup 3', result);

    return resolve(result.data);
  }).catch((err) => {
    return resolve({});
  });
});



export const getCompanyOutreachCampaigns = (companyId) => (dispatch) => new Promise(async (resolve, reject) => {
  const user = auth.currentUser;


  if (user) {
    const outreachVouchersRef = firestore.collection('companyOutreachVouchers').doc(companyId).collection('outreachVouchers');

    const docSnapshot = await outreachVouchersRef.get();

    if (!docSnapshot.docs) {
      return resolve();
    } else {
      const outreachVouchers = {};
      let promises2 = [];

      docSnapshot.docs.map(async (doc) => {
        const data = doc.data();

        outreachVouchers[doc.id] = { ...data };


        console.log('outreachVouchers', outreachVouchers);

        dispatch({
          type: GET_COMPANY_OUTREACH_VOUCHERS,
          payload: outreachVouchers,
        });

        return resolve('success');
      });
    }
  }
});

export const sortCompanyOutreachVouchers = (sortColumn, sortType) => (dispatch) => new Promise(async (resolve, reject) => {
  console.log('action - sortCompanyOutreachVouchers', { sortColumn, sortType });

  return resolve(dispatch({
    type: SORT_COMPANY_OUTREACH_VOUCHERS,
    sortColumn,
    sortType,
  }));
});



export const sortCompanyVouchers = (sortColumn, sortType) => (dispatch) => new Promise(async (resolve, reject) => {
  console.log('action - sortCompanyVouchers', { sortColumn, sortType });

  return resolve(dispatch({
    type: SORT_COMPANY_VOUCHERS,
    sortColumn,
    sortType,
  }));
});


export const cancelCampaignRequest = (campaignId) => ((dispatch) => new Promise(async (resolve, reject) => {

  const cancelCampaignRequestFunction = functions.httpsCallable('cancelCampaignRequest');

  cancelCampaignRequestFunction({
    campaignId,
  }).then((result) => {
    console.log('cancelCampaignRequest result', { result });

    if (result && result.data && result.data.status === 'error') {
      return reject(result.data.data);
    }

    return resolve('success');
  }).catch((err) => {
    console.log(err);
    return reject(err);
  })
}));

export const getVoucherCategories = () => dispatch => {
  const vouchers = firestore.collection('categories');
  vouchers.get().then(function (querySnapshot) {
    let payload = {};
    querySnapshot.forEach(function (doc) {
      payload = { ...payload, [doc.id]: doc.data() }
    });
    dispatch({
      type: GET_VOUCHER_CATEGORIES,
      payload
    });
  })
};

export const createVoucher = (companyId, data) => ((dispatch) => new Promise(async (resolve, reject) => {
  const { availableVouchers, name, totalValue, discount, startDate, endDate, expiry, testMode, customUrl } = data;

  console.log('createVoucher', { data });

  if (!availableVouchers || Object.keys(availableVouchers).length !== 3) {
    return reject('Missing availableVouchers');
  }

  if (!name) {
    return reject('Missing Name');
  }

  let totalValueVar = totalValue;

  if (!totalValue) {
    totalValueVar = 99999999
    // return reject('Missing Total value');
  }

  if (!discount || Object.keys(discount).length !== 3) {
    return reject('Missing discounts');
  }

  let availableVouchersArr = [];
  Object.keys(availableVouchers).map(key => {
    availableVouchersArr.push(availableVouchers[key]);
  })

  const companyRef = firestore.collection('companies').doc(companyId);
  const ownerRef = firestore.collection('owners').doc(companyId);


  const docSnapshot = await companyRef.get();
  const doc2Snapshot = await ownerRef.get();

  let companyStripeId;
  let ownerData;

  if (doc2Snapshot.exists) {
    ownerData = doc2Snapshot.data();

    companyStripeId = ownerData.companyStripeId;
  }

  console.log('ownerData', { ownerData });

  //  console.log('companyStripeId', { companyStripeId });

  if (!docSnapshot.exists) {
    return reject('Error with company data');
  } else {
    const company = docSnapshot.data();

    const voucherFiles = [];

    const { primaryVoucherImage, voucherImages, description, category1, logo, website } = company;
    let backupPrimaryVoucherImage = null;

    //  console.log('ownerData', { company, ownerData });

    //  if (!voucherImages || !voucherImages.length) {
    //    return reject('Missing company images');
    //  }

    //  if (ownerData.liveVouchersCount && ownerData.liveVouchersCount > 3) {
    //    return reject('Camapign already has 3 active campaigns');
    //  }

    if (!primaryVoucherImage) {
      return reject('Missing primary voucher image');
    }

    if (!category1) {
      return reject('Missing company category');
    }

    if (!website) {
      return reject('Missing website');
    }

    if (!description) {
      return reject('Missing description');
    }

    if (!logo) {
      return reject('Missing logo image');
    }

    //  if (!companyStripeId) {
    //    return reject('Connect stripe account');
    //  }

    if (voucherImages) {
      voucherImages.map((image, index) => {
        voucherFiles.push({ file: image });
        if (index === 0) {
          backupPrimaryVoucherImage = image;
        }
      });
    }

    /*  setTimeout(() => {
        console.log('This will run after 1 second!')
  
        return resolve('success');
      }, 2000); */


    /*  const end = new Date(endDate);
    //  const startDateParsed = moment(customStartDate);
  
    //  const endDateParsed = moment(customEndDate);
      const validDates = [];
      for (let d = new Date(startDate); d <= end; d.setDate(d.getDate() + 1)) {
        const date = new Date(d);
  
        let day = date.getDate();
        let month = date.getMonth() + 1;
        const year = date.getFullYear();
  
        if (day < 10) {
          day = '0' + day;
        }
  
        if (month < 10) {
          month = '0' + month;
        }
  
        validDates.push(`${year}-${month}-${day}`);
      }
  
      console.log('validDates', { validDates }); */

    const createVoucherFunction = functions.httpsCallable('createVoucher');

    const dateParsed = Date.parse(startDate);

    //  console.log('data', { startDate2: startDate, availableVouchers: availableVouchersArr, name, totalValue, discount, startDate: dateParsed, companyId, expiry });

    createVoucherFunction({
      availableVouchers: availableVouchersArr, name, totalValue: totalValueVar, discount, startDate: dateParsed, companyId, expiry, testMode, customUrl,
    }).then((result) => {
      console.log('createVoucher result', { result });

      if (result && result.data && result.data.status === 'error') {
        return reject(result.data.data);
      }

      if (result && result.data && result.data.data === 'Missing compliance data') {
        return reject('Missing compliance data');
      }

      if (result && result.data && result.data.data === 'Missing data') {
        return reject('Missing data');
      }

      return resolve('success');
    }).catch((err) => {
      console.log(err);
      return reject(err);
    })

    /*  const vouchersRef = firestore.collection('vouchers');
  
      const vouchersDoc = await vouchersRef.add({
        availableVouchers: availableVouchersArr,
        company: firestore.doc('companies/' + companyId),
        category: firestore.doc('categories/' + category1),
        description: description || '',
        name: name || '',
        totalValue: totalValue || null,
        discount: discount,
        image: primaryVoucherImage || backupPrimaryVoucherImage,
        images: voucherFiles || null,
        created_at: firebase.firestore.FieldValue.serverTimestamp(),
        status: 1,
        isNew: true,
        isActive: false,
      //  campaignDates: validDates || null,
        startDate: startDate ? firebase.firestore.Timestamp.fromDate(startDate) : null,
      //  endDate: endDate ? firebase.firestore.Timestamp.fromDate(endDate) : null,
    });
  } */

    /*  const companyVouchersRef = firestore.collection('companyData').doc(companyId).collection('vouchers').doc(vouchersDoc.id);
  
      await companyVouchersRef.set({
        availableVouchers: availableVouchersArr,
      //  company: `/companies/${companyId}`,
      //  category: `/categories/${category}`,
        company: firestore.doc('companies/' + companyId),
        category: firestore.doc('categories/' + category1),
        description: description || '',
        name: name || '',
        totalValue: totalValue || null,
        discount: discount,
        image: primaryVoucherImage || backupPrimaryVoucherImage,
        images: voucherFiles || null,
      //  image: imagesPaths[0].file,
      //  images: imagesPaths,
        created_at: firebase.firestore.FieldValue.serverTimestamp(),
        status: 'requesting',
        isActive: true,
      }); */

    //  return resolve('success');
  }
  //  } else {
  //    return reject('Missing images');
  //  }
}));


export const updateVoucher = (companyId, voucherId, data) => ((dispatch) => new Promise(async (resolve, reject) => {

  const { availableVouchers, name, discount } = data;

  if (!availableVouchers || Object.keys(availableVouchers).length !== 3) {
    return resolve('missing availableVouchers');
  }

  if (!discount || Object.keys(discount).length !== 3) {
    return resolve('missing discounts');
  }

  let availableVouchersArr = [];
  Object.keys(availableVouchers).map(key => {
    availableVouchersArr.push(availableVouchers[key]);
  });

  const requestVouchersPendingUpdateFunction = functions.httpsCallable('requestVouchersPendingUpdate');

  try {
    const result = await requestVouchersPendingUpdateFunction({
      campaignId: voucherId,
      availableVouchers: availableVouchersArr,
      name: name || '',
      discount: discount,
    });
    const res = result && result.data;
    if (res && res.status === 'success') return resolve('success');
    return reject((res && res.error) || res || 'error');
  } catch (err) {
    console.log(err);
    return reject(err);
  }

}));

export const deleteVoucher = (companyId, voucherId) => ((dispatch) => new Promise(async (resolve) => {
  if (companyId && voucherId) {
    //  const companyVouchersRef = firestore.collection('companyData').doc(companyId).collection('vouchers').doc(voucherId);
    //  const vouchersRef = firestore.collection('vouchers').doc(voucherId);

    //  companyVouchersRef.delete();
    //  vouchersRef.delete();

    return resolve('success');
  }

  return resolve('missing id');
}));


export const requestCampaignStatusChange = (campaignId, status) => ((dispatch) => new Promise(async (resolve, reject) => {

  if (!campaignId) return resolve('Missing campaign id');
  if (!status) return resolve('Missing status');

  const requestCampaignStatusChangeFunction = functions.httpsCallable('requestCampaignStatusChange');

  requestCampaignStatusChangeFunction({
    campaignId,
    status,
  }).then((result) => {
    return resolve(result);
  }).catch((err) => {
    console.log(err);
    return reject(err);
  })
}));

export const cancelRequestStop = (campaignId) => ((dispatch) => new Promise(async (resolve, reject) => {

  if (!campaignId) return resolve('Missing campaign id');

  const cancelRequestStopFunction = functions.httpsCallable('cancelRequestStop');

  cancelRequestStopFunction({
    campaignId,
  }).then((result) => {
    return resolve(result);
  }).catch((err) => {
    console.log(err);
    return reject(err);
  })
}));



export const requestCampaignEdit = (campaignId, value) => ((dispatch) => new Promise(async (resolve, reject) => {
  console.log('requestCampaignEdit', { campaignId, value });

  if (!campaignId) return resolve('Missing campaign id');
  if (!value) return resolve('Missing value');

  const requestCampaignEditFunction = functions.httpsCallable('requestCampaignEdit');

  requestCampaignEditFunction({
    campaignId,
    value,
  }).then((result) => {
    return resolve(result);
  }).catch((err) => {
    console.log(err);
    return reject(err);
  })
}));


export const getVoucherSales = (companyId, campaignFilter, timeFrame, customStartDate, customEndDate) => ((dispatch, getState) => new Promise(async (resolve, reject) => {
  console.log('getVoucherSales', { companyId, campaignFilter, timeFrame, customStartDate, customEndDate });

  let dateLength = 1;
  let startDate;
  let endDate;

  if (timeFrame === 'custom') {
    startDate = moment(customStartDate);

    endDate = moment(customEndDate).add(1, 'days');
  } else if (timeFrame === 'allTime') {

    let allTimeStartDate = customStartDate;
    let allTimeEndDate = new Date();

    startDate = moment(allTimeStartDate);
    endDate = moment(allTimeEndDate).add(1, 'days');
  } else {
    if (timeFrame === 'day') {
      dateLength = 1;
    } else if (timeFrame === 'week') {
      dateLength = 7;
    } else if (timeFrame === 'month') {
      dateLength = 30;
    } else if (timeFrame === 'year') {
      dateLength = 265;
    }

    startDate = moment().subtract(dateLength, 'days');

    endDate = moment().add(1, 'days');
  }

  console.log('startDate', startDate);

  const startDateSplit = startDate.format("DD-MM-YYYY").split("-");
  const endDateSplit = endDate.format("DD-MM-YYYY").split("-");

  let startDay = startDateSplit[0];
  let startMonth = startDateSplit[1];
  const startYear = startDateSplit[2];

  const endDay = endDateSplit[0];
  const endMonth = endDateSplit[1];
  const endYear = endDateSplit[2];

  const ordersRef = firestore.collection('ordersFinished');

  const { vouchers } = getState();

  const companyVouchers = vouchers.vouchers;
  const companyOutreachVouchers = vouchers.outreachVouchers;

  let allDocuments;

  console.log('startDay', startDay, startMonth, startYear);

  if (companyId && (!campaignFilter || campaignFilter === 'all')) {
    console.log('has companyId', companyId);
    allDocuments = await firestore.collection('ordersPerCompany').doc(companyId).collection('totals')
      .get();

    if (!allDocuments.docs) {
      console.log('no allDocuments');
      return resolve();
    } else {
      console.log('has allDocuments');

      let vouchersCount = 0;
      let vouchersValue = 0;
      let voucherTotalFee = 0;
      let vouchersUsedCount = 0;
      let vouchersByDate = {};
      let vouchersUsedByDate = {};
      let vouchersValueByDate = {};

      allDocuments.docs.map(doc => {
        const data = doc.data();
        const id = doc.id;

        console.log(`ordersPerCompany data ${id}`, { data });

        const splitId = id.split("-");
        let reversedId = `${splitId[2]}-${splitId[1]}-${splitId[0]}`;

        vouchersCount = vouchersCount + (data.salesCount || 0);
        vouchersByDate[reversedId] = (data.salesCount || 0);

        vouchersValue = vouchersValue + (data.faceValue || 0);
        vouchersValueByDate[reversedId] = (data.faceValue || 0);


        vouchersUsedCount = vouchersUsedCount + (data.usedCount || 0);
        vouchersUsedByDate[reversedId] = (data.usedCount || 0);

        console.log('vouchersUsedByDate', vouchersUsedByDate);
        console.log('vouchersUsedCount', vouchersUsedCount);

        voucherTotalFee = voucherTotalFee + data.commission;
      });

      console.log('vouchersByDate', { vouchersByDate, vouchersValueByDate, vouchersUsedByDate });

      let dates = [];

      let vouchersByDateNew = {};

      console.log('startDate', startDate, endDate);

      let currDate = startDate.clone().startOf("day");
      let lastDate = endDate.clone();
      const todayDate = moment();

      console.log('lastDate', lastDate);

      let keyFormat = "DD MMM";

      do {
        console.log('currDate do', currDate);
        vouchersByDateNew[currDate.clone().format("DD-MM-YYYY")] = { vouchersCount }


        if (todayDate.clone().format(keyFormat) !== currDate.clone().format(keyFormat)) {
          console.log('dates push', currDate.clone().format(keyFormat));
          dates.push({
            key: currDate.clone().format(keyFormat),
            day: currDate.clone().toDate(),
            value: vouchersByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
            vouchersCount: vouchersByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
            vouchersUsed: vouchersUsedByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
            vouchersValue: vouchersValueByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
          });
        }

      } while (currDate.add(1, "days").diff(lastDate) < -(60 * 60 * 24 * 1000 * 2));

      console.log('GET_VOUCHER_SALES_DATA call 1', {
        vouchersCount,
        vouchersUsedCount,
        vouchersValue,
        voucherTotalFee,
        dates,
      });

      if (todayDate.clone().format(keyFormat) !== currDate.clone().format(keyFormat) && (currDate.clone().format(keyFormat) !== lastDate.clone().format(keyFormat))) {
        console.log('dates push', currDate.clone().format(keyFormat));

        dates.push({
          key: currDate.clone().format(keyFormat),
          day: currDate.clone().toDate(),
          value: vouchersByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
          vouchersCount: vouchersByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
          vouchersUsed: vouchersUsedByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
          vouchersValue: vouchersValueByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
        });
      }

      console.log('lastDate todayDate', todayDate.clone().startOf("day").format("DD-MM-YYYY HH:mm:ss"), lastDate.clone().subtract(1, 'days').startOf("day").format("DD-MM-YYYY HH:mm:ss"));

      if (timeFrame !== 'custom' || (timeFrame === 'custom' && lastDate.clone().subtract(1, 'days').startOf("day").format("DD-MM-YYYY HH:mm:ss") === todayDate.clone().startOf("day").format("DD-MM-YYYY HH:mm:ss"))) {
        const todayDateSplit = todayDate.format("DD-MM-YYYY").split("-");

        const todayDay = todayDateSplit[0];
        const todayMonth = todayDateSplit[1];
        const todayYear = todayDateSplit[2];

        const todayDocuments = await ordersRef
          .where('companyId', '==', companyId)
          .where('paymentDate', ">=", new Date(`${todayYear}/${todayMonth}/${parseInt(todayDay)}`))
          .get();

        const todayUsedDocuments = await ordersRef
          .where('companyId', '==', companyId)
          .where('usedDate', ">=", new Date(`${todayYear}/${todayMonth}/${parseInt(todayDay)}`))
          .get();

        if (!todayDocuments.docs && !todayUsedDocuments.docs) {
          console.log('has no todayDocuments');
          return resolve();
        } else {
          console.log('todayDocuments', todayDocuments.docs, companyId, new Date(`${todayYear}/${todayMonth}/${parseInt(todayDay)}`));
          console.log('todayUsedDocuments', todayUsedDocuments.docs);

          console.log('companyVouchers', companyVouchers);

          let date = todayDay;
          let month = todayMonth;
          const year = todayYear;

          if (todayDocuments) {
            todayDocuments.docs.map(doc => {
              const data = doc.data();
              const id = doc.id;

              console.log(`today data 1 ${id}`, { data });

              const { application_fee_amount, voucherStep, voucherId, used, voucher, faceValue } = data;

              const splitVoucherId = voucherId;

              let dateKeyLong = `${date}-${month}-${year}`;
              let dateKey = `${date}-${month}`;

              console.log('dateKey', dateKey, splitVoucherId, voucherStep);

              vouchersByDate[dateKeyLong] = vouchersByDate[dateKeyLong] ? (vouchersByDate[dateKeyLong] + 1) : 1;
              vouchersCount = vouchersCount + 1;

              vouchersValue = vouchersValue + (faceValue || 0);
              vouchersValueByDate[dateKeyLong] = vouchersValueByDate[dateKeyLong] ? (vouchersValueByDate[dateKeyLong] + (faceValue || 0)) : (faceValue || 0);

              console.log('vouchersValueByDate', vouchersValueByDate);

              if (application_fee_amount) {
                voucherTotalFee = voucherTotalFee + application_fee_amount;
              }
            });
          }

          if (todayUsedDocuments) {
            todayUsedDocuments.docs.map(doc => {
              const data = doc.data();
              const id = doc.id;

              console.log(`today used data 2 ${id}`, { data });

              const { used } = data;

              if (used) {
                vouchersUsedCount = vouchersUsedCount + 1;

                let dateKeyLong = `${date}-${month}-${year}`;
                let dateKey = `${date}-${month}`;

                console.log('dateKey', dateKey);

                vouchersUsedByDate[dateKeyLong] = vouchersUsedByDate[dateKeyLong] ? (vouchersUsedByDate[dateKeyLong] + 1) : 1;
              }
            });
          }

          console.log('vouchersByDate 2', { vouchersByDate, vouchersValueByDate, vouchersUsedByDate });

          let currDate = todayDate.clone().startOf("day");

          let keyFormat = "DD MMM";

          dates.push({
            key: currDate.clone().format(keyFormat),
            day: currDate.clone().toDate(),
            value: vouchersByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
            vouchersCount: vouchersByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
            vouchersUsed: vouchersUsedByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
            vouchersValue: vouchersValueByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
          });
        }
      }

      console.log('GET_VOUCHER_SALES_DATA call 2', {
        vouchersCount,
        vouchersUsedCount,
        vouchersValue,
        voucherTotalFee,
        dates,
      });

      dispatch({
        type: GET_VOUCHER_SALES_DATA,
        vouchersCount,
        vouchersUsedCount,
        vouchersValue,
        voucherTotalFee,
        vouchersByDate: dates,
      });

      return resolve();
    }
  } else if (campaignFilter === 'campaigns' || campaignFilter === 'vouchReach') {





    console.log('HAS VOUCHER ID', { campaignFilter });

    let voucherRefPath = 'vouchers';
    let vouchersData = {};

    if (campaignFilter === 'campaigns') {
      vouchersData = companyVouchers || {};
      voucherRefPath = 'vouchers';
    } else if (campaignFilter === 'vouchReach') {
      vouchersData = companyOutreachVouchers || {};
      voucherRefPath = 'outreachVouchers';
    }

    console.log('vouchersData', vouchersData, voucherRefPath);

    let vouchersCount = 0;
    let vouchersValue = 0;
    let voucherTotalFee = 0;
    let vouchersUsedCount = 0;
    let vouchersByDate = {};
    let vouchersUsedByDate = {};
    let vouchersValueByDate = {};

    const todayDate = moment();

    const todayDateSplit = todayDate.format("DD-MM-YYYY").split("-");

    const todayDay = todayDateSplit[0];
    const todayMonth = todayDateSplit[1];
    const todayYear = todayDateSplit[2];

    const promises = [];

    Object.keys(vouchersData).map(async (voucherDataKey) => promises.push(new Promise(async (resolve2) => {
      const voucherData = vouchersData[voucherDataKey];

      allDocuments = await firestore.collection('ordersPerCampaign').doc(voucherDataKey).collection('totals')
        .get()
        // A campaign with no totals yet, or one the rules refuse, counts as no sales instead of stopping the whole view
        .catch(() => ({ docs: [] }));

      if (!allDocuments.docs) {
      //  return resolve2();
      } else {
        console.log('has allDocuments ordersPerCampaign', voucherDataKey);

        allDocuments.docs.map(doc => {
          const data = doc.data();
          const id = doc.id;

          console.log(`data ${id}`, { data });

          const splitId = id.split("-");
          let reversedId = `${splitId[2]}-${splitId[1]}-${splitId[0]}`;

          vouchersCount = vouchersCount + (data.salesCount || 0);
          if (vouchersByDate[reversedId]) {
            vouchersByDate[reversedId] = (vouchersByDate[reversedId] + (data.salesCount || 0));
          } else {
            vouchersByDate[reversedId] = (data.salesCount || 0);
          }

          vouchersValue = vouchersValue + (data.faceValue || 0);
          if (vouchersValueByDate[reversedId]) {
            vouchersValueByDate[reversedId] = (vouchersValueByDate[reversedId] + (data.faceValue || 0));
          } else {
            vouchersValueByDate[reversedId] = (data.faceValue || 0);
          }

          vouchersUsedCount = vouchersUsedCount + (data.usedCount || 0);
          if (vouchersUsedByDate[reversedId]) {
            vouchersUsedByDate[reversedId] = (vouchersUsedByDate[reversedId] + (data.usedCount || 0));
          } else {
            vouchersUsedByDate[reversedId] = (data.usedCount || 0);
          }

          voucherTotalFee = voucherTotalFee + data.commission;
        });

        /*
        console.log('vouchersByDate', { vouchersByDate, vouchersValueByDate, vouchersUsedByDate });

        let dates = [];

        let vouchersByDateNew = {};

        let currDate = startDate.clone().startOf("day");
        let lastDate = endDate.clone().startOf("day");

        let keyFormat = "DD MMM";

        do {
          vouchersByDateNew[currDate.clone().format("DD-MM-YYYY")] = { vouchersCount }

          dates.push({
            key: currDate.clone().format(keyFormat),
            day: currDate.clone().toDate(),
            value: vouchersByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
            vouchersCount: vouchersByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
            vouchersUsed: vouchersUsedByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
            vouchersValue: vouchersValueByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
          });
        } while (currDate.add(1, "days").diff(lastDate) < -(60 * 60 * 24 * 1000 * 2));

        console.log('GET_VOUCHER_SALES_DATA call 1', {
          vouchersCount,
          vouchersUsedCount,
          vouchersValue,
          voucherTotalFee,
          dates,
        }); */

        /*
        if (todayDate.clone().format(keyFormat) !== currDate.clone().format(keyFormat) && (currDate.clone().format(keyFormat) !== lastDate.clone().format(keyFormat))) {
          console.log('dates push', currDate.clone().format(keyFormat));

          dates.push({
            key: currDate.clone().format(keyFormat),
            day: currDate.clone().toDate(),
            value: vouchersByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
            vouchersCount: vouchersByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
            vouchersUsed: vouchersUsedByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
            vouchersValue: vouchersValueByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
          });
        } */
      }

      console.log('fetch today documents', todayYear, todayMonth, todayDay);

      let filterId = 'campaignId';

      if (campaignFilter === 'vouchReach') {
        filterId = 'campaignId';
      }

      const todayDocuments = await ordersRef
        .where(filterId, '==', voucherDataKey)
        .where('companyId', '==', companyId)
        .where('paymentDate', ">=", new Date(`${todayYear}/${todayMonth}/${parseInt(todayDay)}`))
        .get();

      const todayUsedDocuments = await ordersRef
        .where(filterId, '==', voucherDataKey)
        .where('companyId', '==', companyId)
        .where('usedDate', ">=", new Date(`${todayYear}/${todayMonth}/${parseInt(todayDay)}`))
        .get();

      if (!todayDocuments.docs && !todayUsedDocuments.docs) {
       // return resolve2();
      } else {
        console.log('todayDocuments', todayDocuments.docs);

        let date = todayDay;
        let month = todayMonth;
        const year = todayYear;

        let dateKeyLong = `${date}-${month}-${year}`;

        if (todayDocuments) {
          todayDocuments.docs.map(doc => {
            const data = doc.data();
            const id = doc.id;

            console.log(`today data 2 ${id}`, { data });

            const { application_fee_amount, voucherStep, customFaceValue } = data;

            vouchersByDate[dateKeyLong] = vouchersByDate[dateKeyLong] ? (vouchersByDate[dateKeyLong] + 1) : 1;

            vouchersCount = vouchersCount + 1;

            if (campaignFilter === 'vouchReach') {
              if (parseInt(customFaceValue, 10)) {
                vouchersValue = vouchersValue + parseInt(customFaceValue, 10);
                vouchersValueByDate[dateKeyLong] = vouchersValueByDate[dateKeyLong] ? (vouchersValueByDate[dateKeyLong] + parseInt(customFaceValue, 10)) : parseInt(customFaceValue, 10);
              }
            } else {
              if (parseInt(voucherStep, 10) || parseInt(voucherStep, 10) === 0) {
                vouchersValue = vouchersValue + voucherData.availableVouchers[parseInt(voucherStep, 10)];
                vouchersValueByDate[dateKeyLong] = vouchersValueByDate[dateKeyLong] ? (vouchersValueByDate[dateKeyLong] + voucherData.availableVouchers[parseInt(voucherStep, 10)]) : voucherData.availableVouchers[parseInt(voucherStep, 10)];
              }
            }

            if (application_fee_amount) {
              voucherTotalFee = voucherTotalFee + application_fee_amount;
            }
          });
        }

        if (todayUsedDocuments.docs) {
          todayUsedDocuments.docs.map(doc => {
            const data = doc.data();
            const id = doc.id;

            console.log(`today used data 2 ${id}`, { data });

            const { used } = data;

            if (used) {
              vouchersUsedCount = vouchersUsedCount + 1;

              vouchersUsedByDate[dateKeyLong] = vouchersUsedByDate[dateKeyLong] ? (vouchersUsedByDate[dateKeyLong] + 1) : 1;
            }
          });
        }
        /* 
        console.log('vouchersByDate 2', { vouchersByDate, vouchersValueByDate, vouchersUsedByDate });

        let currDate = todayDate.clone().startOf("day");

        let keyFormat = "DD MMM";

        dates.push({
          key: currDate.clone().format(keyFormat),
          day: currDate.clone().toDate(),
          value: vouchersByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
          vouchersCount: vouchersByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
          vouchersUsed: vouchersUsedByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
          vouchersValue: vouchersValueByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
        }); */
      }

      /* console.log('GET_VOUCHER_SALES_DATA call 2', {
        vouchersCount,
        vouchersUsedCount,
        vouchersValue,
        voucherTotalFee,
        dates,
      });

      dispatch({
        type: GET_VOUCHER_SALES_DATA,
        vouchersCount,
        vouchersUsedCount,
        vouchersValue,
        voucherTotalFee,
        vouchersByDate: dates,
      }); */

      console.log('vouchersByDate for campaign', { voucherDataKey, vouchersCount, vouchersByDate, vouchersValueByDate, vouchersUsedByDate });

      return resolve2();
    })));

    await Promise.allSettled(promises);

    console.log('vouchersByDate after all', { vouchersByDate, vouchersValueByDate, vouchersUsedByDate });

    let dates = [];

    let vouchersByDateNew = {};

    let currDate = startDate.clone().startOf("day");
    let lastDate = endDate.clone().startOf("day");

    let keyFormat = "DD MMM";

    do {
      vouchersByDateNew[currDate.clone().format("DD-MM-YYYY")] = { vouchersCount }

      console.log('dates push', currDate.clone().format(keyFormat));
      dates.push({
        key: currDate.clone().format(keyFormat),
        day: currDate.clone().toDate(),
        value: vouchersByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
        vouchersCount: vouchersByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
        vouchersUsed: vouchersUsedByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
        vouchersValue: vouchersValueByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
      });
    } while (currDate.add(1, "days").diff(lastDate) < -(60 * 60 * 24 * 1000 * 2));

    console.log('GET_VOUCHER_SALES_DATA call 1', {
      vouchersCount,
      vouchersUsedCount,
      vouchersValue,
      voucherTotalFee,
      dates,
    });


    if (todayDate.clone().format(keyFormat) !== currDate.clone().format(keyFormat) && (currDate.clone().format(keyFormat) !== lastDate.clone().format(keyFormat))) {
      console.log('dates push', currDate.clone().format(keyFormat));

      dates.push({
        key: currDate.clone().format(keyFormat),
        day: currDate.clone().toDate(),
        value: vouchersByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
        vouchersCount: vouchersByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
        vouchersUsed: vouchersUsedByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
        vouchersValue: vouchersValueByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
      });
    } 

    console.log('vouchersByDate 2', { vouchersByDate, vouchersValueByDate, vouchersUsedByDate });

    let currDate2 = todayDate.clone().startOf("day");

    console.log('dates push', currDate2.clone().format(keyFormat));
    dates.push({
      key: currDate2.clone().format(keyFormat),
      day: currDate2.clone().toDate(),
      value: vouchersByDate[currDate2.clone().format("DD-MM-YYYY")] || 0,
      vouchersCount: vouchersByDate[currDate2.clone().format("DD-MM-YYYY")] || 0,
      vouchersUsed: vouchersUsedByDate[currDate2.clone().format("DD-MM-YYYY")] || 0,
      vouchersValue: vouchersValueByDate[currDate2.clone().format("DD-MM-YYYY")] || 0,
    });

    console.log('GET_VOUCHER_SALES_DATA call 2', {
      vouchersCount,
      vouchersUsedCount,
      vouchersValue,
      voucherTotalFee,
      dates,
    });

    dispatch({
      type: GET_VOUCHER_SALES_DATA,
      vouchersCount,
      vouchersUsedCount,
      vouchersValue,
      voucherTotalFee,
      vouchersByDate: dates,
    });








  } else if (campaignFilter) {
    console.log('HAS VOUCHER ID', { campaignFilter });

    let voucherRefPath = 'vouchers';
    let voucherData = {};

    if (companyVouchers[campaignFilter]) {
      voucherData = companyVouchers[campaignFilter];
      voucherRefPath = 'vouchers';
    } else if (companyOutreachVouchers[campaignFilter]) {
      voucherData = companyVouchers[campaignFilter];
      voucherRefPath = 'outreachVouchers';
    }

    console.log('voucherData', voucherData, voucherRefPath);

    const voucherRef = firestore.collection(voucherRefPath).doc(campaignFilter);

    allDocuments = await firestore.collection('ordersPerCampaign').doc(campaignFilter).collection('totals')
      .get()
      // A campaign with no totals yet, or one the rules refuse, counts as no sales instead of stopping the whole view
      .catch(() => ({ docs: [] }));

    if (!allDocuments.docs) {
      console.log('no allDocuments');
      return resolve();
    } else {
      console.log('has allDocuments');

      let vouchersCount = 0;
      let vouchersValue = 0;
      let voucherTotalFee = 0;
      let vouchersUsedCount = 0;
      let vouchersByDate = {};
      let vouchersUsedByDate = {};
      let vouchersValueByDate = {};

      allDocuments.docs.map(doc => {
        const data = doc.data();
        const id = doc.id;

        console.log(`data ${id}`, { data });

        const splitId = id.split("-");
        let reversedId = `${splitId[2]}-${splitId[1]}-${splitId[0]}`;

        vouchersCount = vouchersCount + (data.salesCount || 0);
        vouchersByDate[reversedId] = (data.salesCount || 0);

        vouchersValue = vouchersValue + (data.faceValue || 0);
        vouchersValueByDate[reversedId] = (data.faceValue || 0);


        vouchersUsedCount = vouchersUsedCount + (data.usedCount || 0);
        vouchersUsedByDate[reversedId] = (data.usedCount || 0);

        voucherTotalFee = voucherTotalFee + data.commission;
      });

      console.log('vouchersByDate', { vouchersByDate, vouchersValueByDate, vouchersUsedByDate });

      let dates = [];

      let vouchersByDateNew = {};

      let currDate = startDate.clone().startOf("day");
      let lastDate = endDate.clone().startOf("day");

      let keyFormat = "DD MMM";

      do {
        vouchersByDateNew[currDate.clone().format("DD-MM-YYYY")] = { vouchersCount }

        dates.push({
          key: currDate.clone().format(keyFormat),
          day: currDate.clone().toDate(),
          value: vouchersByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
          vouchersCount: vouchersByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
          vouchersUsed: vouchersUsedByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
          vouchersValue: vouchersValueByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
        });
      } while (currDate.add(1, "days").diff(lastDate) < -(60 * 60 * 24 * 1000 * 2));

      console.log('GET_VOUCHER_SALES_DATA call 1', {
        vouchersCount,
        vouchersUsedCount,
        vouchersValue,
        voucherTotalFee,
        dates,
      });

      const todayDate = moment();

      const todayDateSplit = todayDate.format("DD-MM-YYYY").split("-");

      const todayDay = todayDateSplit[0];
      const todayMonth = todayDateSplit[1];
      const todayYear = todayDateSplit[2];

      if (todayDate.clone().format(keyFormat) !== currDate.clone().format(keyFormat) && (currDate.clone().format(keyFormat) !== lastDate.clone().format(keyFormat))) {
        console.log('dates push', currDate.clone().format(keyFormat));

        dates.push({
          key: currDate.clone().format(keyFormat),
          day: currDate.clone().toDate(),
          value: vouchersByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
          vouchersCount: vouchersByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
          vouchersUsed: vouchersUsedByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
          vouchersValue: vouchersValueByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
        });
      }

      const todayDocuments = await ordersRef
        .where('voucherId', '==', campaignFilter)
        .where('companyId', '==', companyId)
        .where('paymentDate', ">=", new Date(`${todayYear}/${todayMonth}/${parseInt(todayDay)}`))
        .get();

      const todayUsedDocuments = await ordersRef
        .where('voucherId', '==', campaignFilter)
        .where('companyId', '==', companyId)
        .where('usedDate', ">=", new Date(`${todayYear}/${todayMonth}/${parseInt(todayDay)}`))
        .get();

      if (!todayDocuments.docs && !todayUsedDocuments.docs) {
        console.log('has no todayDocuments');
        return resolve();
      } else {
        console.log('todayDocuments', todayDocuments.docs);

        let date = todayDay;
        let month = todayMonth;
        const year = todayYear;

        let dateKeyLong = `${date}-${month}-${year}`;

        if (todayDocuments) {
          todayDocuments.docs.map(doc => {
            const data = doc.data();
            const id = doc.id;

            console.log(`today data 2 ${id}`, { data });

            const { application_fee_amount, voucherStep } = data;

            vouchersByDate[dateKeyLong] = vouchersByDate[dateKeyLong] ? (vouchersByDate[dateKeyLong] + 1) : 1;

            vouchersCount = vouchersCount + 1;

            if (parseInt(voucherStep, 10) || parseInt(voucherStep, 10) === 0) {
              console.log('voucherDatavoucherData', voucherData);

              vouchersValue = vouchersValue + voucherData.availableVouchers[parseInt(voucherStep, 10)];
              vouchersValueByDate[dateKeyLong] = vouchersValueByDate[dateKeyLong] ? (vouchersValueByDate[dateKeyLong] + voucherData.availableVouchers[parseInt(voucherStep, 10)]) : voucherData.availableVouchers[parseInt(voucherStep, 10)];
            }

            if (application_fee_amount) {
              voucherTotalFee = voucherTotalFee + application_fee_amount;
            }
          });
        }

        if (todayUsedDocuments.docs) {
          todayUsedDocuments.docs.map(doc => {
            const data = doc.data();
            const id = doc.id;

            console.log(`today used data 2 ${id}`, { data });

            const { used } = data;

            if (used) {
              vouchersUsedCount = vouchersUsedCount + 1;

              vouchersUsedByDate[dateKeyLong] = vouchersUsedByDate[dateKeyLong] ? (vouchersUsedByDate[dateKeyLong] + 1) : 1;
            }
          });
        }

        console.log('vouchersByDate 2', { vouchersByDate, vouchersValueByDate, vouchersUsedByDate });

        let currDate = todayDate.clone().startOf("day");

        let keyFormat = "DD MMM";

        dates.push({
          key: currDate.clone().format(keyFormat),
          day: currDate.clone().toDate(),
          value: vouchersByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
          vouchersCount: vouchersByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
          vouchersUsed: vouchersUsedByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
          vouchersValue: vouchersValueByDate[currDate.clone().format("DD-MM-YYYY")] || 0,
        });
      }

      console.log('GET_VOUCHER_SALES_DATA call 2', {
        vouchersCount,
        vouchersUsedCount,
        vouchersValue,
        voucherTotalFee,
        dates,
      });

      dispatch({
        type: GET_VOUCHER_SALES_DATA,
        vouchersCount,
        vouchersUsedCount,
        vouchersValue,
        voucherTotalFee,
        vouchersByDate: dates,
      });

      return resolve();
    }
  }
}))


/* export const getVoucherCompanies = () => dispatch => {
    const vouchers = firestore.collection(DB_TABLE_NAME.companies);
    vouchers.get().then(function(querySnapshot) {
        let payload = {};
        querySnapshot.forEach(function(doc) {
            payload = {...payload, [doc.id]: doc.data()}
        });
        dispatch({
            type: GET_VOUCHER_COMPANIES,
            payload
        });
    })
};  */
